<!-- 任务列表 -->
<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div class="querySearch">
        <div class="searchItem">
          <span>任务名称：</span>
          <el-select
            v-model="queryInfo.task_id"
            filterable
            placeholder="支持关键词模糊查询"
            :clearable="true"
            size="mini"
          >
            <el-option
              v-for="item in nameOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="searchItem">
          <span>时间：</span>
          <el-date-picker
            v-model="timeFrame"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            @change="selectData"
            clearable
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="searchItem">
          <span>指标说明：</span>
          <el-popover placement="top-start" width="200" trigger="hover">
            <div v-html="selfnumzbsm"></div>
            <i class="el-icon-question el-icon--right" slot="reference"></i>
          </el-popover>
        </div>
        <!-- <el-button type="primary" size="small" @click="queryTable"
        >搜索</el-button
      >
      <el-button type="warning" size="small" @click="resetQuery"
        >重置</el-button
      > -->
        <MyButton
          value="搜索"
          size="medium"
          icon="el-icon-search"
          type="1"
          @click="queryTable('search')"
        ></MyButton>
        <MyButton
          value="重置"
          size="medium"
          type="2"
          @click="resetQuery"
        ></MyButton>
      </div>
      <div v-if="role == 'admin'">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="grid-content bg-purple flex-box item_a1">
              <div>呼出次数</div>
              <div>{{ allProgressData.zhixing_total }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple flex-box item_a2">
              <div>接通次数</div>
              <div>
                <span>{{ allProgressData.jietong_total }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple flex-box item_a3">
              <div>接通率</div>
              <div>{{ allProgressData.jietong_per }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple flex-box item_a4">
              <div>计费/账户余额</div>
              <div>
                <span>{{ allProgressData.cost }}</span> /
                <span class="activeNumber">{{ allProgressData.fee }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="table">
        <el-table
          :data="tableList"
          stripe
          style="width: 100%"
          border
          @sort-change="sortChange"
        >
          <el-table-column prop="realname" label="姓名" align="center" />
          <el-table-column
            prop="zhixing_people"
            label="呼出人数"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="jietong_people"
            label="接通人数"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="youxiao_jietong_people"
            label="有效接通人数"
            align="center"
          />
          <el-table-column
            prop="zhixing_count"
            label="呼出次数"
            align="center"
            sortable="custom"
          />
          <el-table-column
            prop="jietong_count"
            label="接通次数"
            align="center"
            sortable="custom"
          />
          <el-table-column prop="jietong_per" label="接通率" align="center" />
          <el-table-column
            prop="youxiao_jietong_count"
            label="有效接通次数"
            align="center"
          />
          <el-table-column
            prop="youxao_jietong_per"
            label="有效接通率"
            align="center"
          />
          <el-table-column
            prop="tonghua_time"
            label="通话时长"
            align="center"
          />
          <el-table-column prop="cost_time" label="计费时长" align="center" />
          <el-table-column prop="cost" label="计费" align="center" />
          <el-table-column label="操作">
            <template slot-scope="scope">
              <!-- <el-button type="text" size="mini" @click="viewDetails(scope.row)"
                >查看详情</el-button
              > -->

              <span class="operationItem" @click="viewDetails(scope.row)"
                >查看详情</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import commonApi from "@/api/common";
import { clearObj, deepClone } from "@/utils";
import TableComponents from "@/components/TableComponents.vue";
import MyButton from "@/components/MyButton.vue";
// 数据统计
export default {
  name: "StatisticsData",
  components: { MyButton },
  data() {
    return {
      loading: false,
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        start_time: "",
        end_time: "",
        task_id: "",
        sort_key: "",
        sort_value: "",
      },
      tableList: [],
      timeFrame: [],
      selfnumzbsm: "",
      nameOptions: [],
      allProgressData: {},
      role: "",
    };
  },
  computed: {},
  created() {
    // this.role = this.$store.state.user.userInfo.role;
    this.getMe();
    this.getTobAllTask();
    this.getDic();
    this.queryTable();
  },
  methods: {
    async getMe() {
      const res = await commonApi.tobMe();
      if (res.code === 200) {
        this.role = res.data.role;
        // console.log("getMe", res.data.role);
      }
    },

    sortChange(e) {
      // 升降序
      this.queryInfo.page = 1;
      console.log("e------", e);
      if (e.order === "ascending") {
        this.queryInfo.sort_key = e.prop;
        this.queryInfo.sort_value = "asc";
        this.queryTable();
      } else if (e.order === "descending") {
        this.queryInfo.sort_key = e.prop;
        this.queryInfo.sort_value = "desc";
        this.queryTable();
      } else {
        this.queryInfo.sort_key = "";
        this.queryInfo.sort_value = "";
        this.queryTable();
      }
    },

    viewDetails(row) {
      console.log("viewDetails", row);
      if (row.username == "juheng") {
        this.$router.push({
          path: "/callPhone",
        });
      } else {
        this.$router.push({
          path: "/callPhone",
          query: {
            staff_id: row.id,
            type: 2,
            task_id: this.queryInfo.task_id ? this.queryInfo.task_id : "",
          },
        });
      }
    },
    getTobAllTask() {
      commonApi.getTobAllTask().then((res) => {
        if (res.code === 200) {
          this.nameOptions = res.data;
        }
      });
    },
    // 获取问号中的显示内容
    getDic() {
      commonApi.getInfoToName({ name: "outwardcalsm" }).then((res) => {
        if (res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.key === "selfnumzbsm") {
              this.selfnumzbsm = item.value;
            }
          });
        }
      });
    },
    // 列表数据
    async queryTable(_type) {
      let params = deepClone(this.queryInfo);
      const res = await commonApi.getTobDataTongJi(params);
      if (res.code == 200) {
        this.queryInfo.total = res.data.total;
        this.tableList = res.data.data;
        this.allProgressData = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },
    resetQuery() {
      this.timeFrame = [];
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
        start_time: "",
        end_time: "",
        task_id: "",
        sort_key: "",
        sort_value: "",
      };
      this.queryTable();
    },
    // 选择日期
    selectData(e) {
      if (e) {
        this.queryInfo.start_time = e[0];
        this.queryInfo.end_time = e[1];
      } else {
        this.queryInfo.start_time = "";
        this.queryInfo.end_time = "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 10px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 230px;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 10px 0;
    .el-button {
      margin: 0 5px 10px 0;
    }
  }

  // 表格数据
  //   .table {
  //     min-height: calc(100vh - 330px);
  //     border: 1px solid #ddd;
  //     border-radius: 10px;
  //     .studentLabel {
  //       display: inline-block;
  //       padding: 5px 10px;
  //       background-color: #409eff;
  //       color: #fff;
  //       border-radius: 4px;
  //       margin: 0 5px 5px 0;
  //     }
  //   }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }
  .operationItem:hover {
    color: red;
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}

// 添加标签样式
/deep/ .editLabelClass {
  display: flex;
  align-items: flex-start;
  .p1 {
    margin-right: 20px;
    width: 70px;
    line-height: 30px;
  }
  .p2 {
    flex: 1;
  }
  .el-tag {
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .searchItem {
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
}
.editLabelClass + .editLabelClass {
  margin-top: 20px;
}
/deep/.el-input-number {
  width: 250px;
}

/deep/.noData {
  padding-top: 200px;
  .text {
    text-align: center;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .openClick {
    text-align: center;
  }
}

.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.flex-box {
  margin: 10px 0;
  display: flex;
  justify-content: space-around;
  height: 80px;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
}
.activeNumber {
  color: #f40;
}
.item_a1 {
  background-color: #f5f3ff;
}
.item_a2 {
  background-color: #edfffa;
}
.item_a3 {
  background-color: #fff6ed;
}
.item_a4 {
  background-color: #ffefef;
}
/deep/.el-dialog__footer {
  text-align: center;
}
</style>
